import Point from 'ol/geom/Point.js';
// import Feature from 'ol/Feature';
import Icon from 'ol/style/icon';
// import Style from 'ol/style/Style';
// import GeoJSON from 'ol/format/GeoJSON';
import { Tooltip } from 'chart.js';
import Overlay from "ol/Overlay";
import { PopoverConfig } from 'ngx-bootstrap/popover';
declare var ol: any;
import * as $ from 'jquery';
import * as moment from 'moment';
import 'ol/ol.css';
import Feature from 'ol/Feature';
import Map from 'ol/Map';
import View from 'ol/View';
import GeoJSON from 'ol/format/GeoJSON';
import Circle from 'ol/geom/Circle';
import {Tile as TileLayer, Vector as VectorLayer} from 'ol/layer';
import {OSM, Vector as VectorSource} from 'ol/source';
import {Circle as CircleStyle, Fill, Stroke, Style} from 'ol/style';
import OlMap from "ol/map";
import OlTileWMS from "ol/source/TileWMS";
import OlTileLayer from "ol/layer/tile";
import OlView from "ol/View";
export const style={

  'LineString': new Style({
    stroke: new Stroke({
      color: 'green',
      width: 1
    })
  }),
  'MultiLineString': new Style({
    stroke: new Stroke({
      color: 'green',
      width: 1
    })
  }),
  'MultiPolygon': new Style({
    stroke: new Stroke({
      color: 'yellow',
      width: 1
    }),
    fill: new Fill({
      color: 'green'
    })
  }),
  'Polygon': new Style({
    stroke: new Stroke({
      color: 'blue',
      lineDash: [4],
      width: 3
    }),
    fill: new Fill({
      color: 'rgba(0, 0, 255, 0.1)'
    })
  }),
  'GeometryCollection': new Style({
    stroke: new Stroke({
      color: 'magenta',
      width: 2
    }),
    fill: new Fill({
      color: 'magenta'
    }),
    image: new CircleStyle({
      radius: 10,
      fill: null,
      stroke: new Stroke({
        color: 'magenta'
      })
    })
  }),
  'Circle': new Style({
    stroke: new Stroke({
      color: 'red',
      width: 2
    }),
    fill: new Fill({
      color: 'rgba(255,0,0,0.2)'
    })
  })
};
export var transform=(geojson)=>{
    return geojson.features.map((item)=>{
    switch(item.geometry.type){
      case 'MultiPolygon':
        item.geometry.coordinates=item.geometry.coordinates.map((a1)=>{
          a1=a1.map(a2=>{
            a2=a2.map(a3=>{
              // return a3;
              return ol.proj.transform(
                        a3,
                        "EPSG:4326",
                        "EPSG:900913"
                      )

            })
            return a2;
          })
          return a1;
        })
        break;
    }
    return item;
  })
}
export var styleFunction = function(feature) {
  return style[feature.getGeometry().getType()];
};
declare var deemap_url;
export const source= new OlTileWMS({
  // url: "https://www.deemap.com/DeeMap/gwc/service/wms?customer_key=1xwg5CAuhFz8z2Rw",
  url:deemap_url,
  params: {
    "LAYERS": localStorage.getItem("lang") == 'EN' ? "DeeMap2_THA_Map_EN" : "DeeMap2_THA_Map",
    "FORMAT": "image/png8",
    "VERSION": "1.1.1",
    "SRS": "EPSG:900913",
    "TILES": true,
  }
})
export const layer=new OlTileLayer({
  source: source
});
export const view = new OlView({
  center: ol.proj.transform(
    [100.6037284, 13.6768896],
    "EPSG:4326",
    "EPSG:900913"
  ), // lon lat
  zoom: 10,
  projection: "EPSG:900913",
  minZoom: 5,
  maxZoom: 21
}, 1000);
export var map=(geojson,target)=>{
  var vectorSource;
  if(geojson!=null){
    geojson.features=transform(geojson);
    vectorSource = new VectorSource({
      features: (new GeoJSON()).readFeatures(geojson)
    });
  }else{
    vectorSource = new VectorSource({
      features: []
    });
  }

  var vectorLayer = new VectorLayer({
    source: vectorSource,
    style: styleFunction
  });

  return new OlMap({
    target:target,
    layers: [layer, vectorLayer],
    view: view
  });

}
export var vectorLayer=(geojson)=>{
  var vectorSource;
  if(geojson!=null){
    geojson.features=transform(geojson);
    vectorSource = new VectorSource({
      features: (new GeoJSON()).readFeatures(geojson)
    });
  }else{
    vectorSource = new VectorSource({
      features: []
    });
  }

  return new VectorLayer({
    source: vectorSource,
    style: styleFunction
  });
}
